import { useState, useEffect } from "react"
import Image from "next/image";

const TeamMember = {
  "anuveyatsu": {
    role: "Senior Software Engineer",
    fullname: "Anuar Ustayev"
  },
  "rufuspollock": {
    role: "President",
    fullname: "Rufus Pollock"
  },
  "zelima": {
    role: "Senior Software Engineer",
    fullname: "Irakli Mchedlishvili"
  },
  "SusanBot85": {
    role: "Project Manager",
    fullname: "Susan Botha"
  },
  "steveoni": {
    role: "Software Engineer",
    fullname: "Stephen Oni"
  },
  "sagargg": {
    role: "Software Engineer",
    fullname: "Sagar Ghimire"
  },
  "popovayoana": {
    role: "Marketing & Business Development",
    fullname: "Yoana Popova"
  },
  "osahon-okungbowa": {
    role: "Head of Delivery & Project Manager",
    fullname: "Osahon Okungbowa"
  },
  "MuhammadIsmailShahzad": {
    role: "Software Engineer",
    fullname: "Muhammad Ismail Shahzad"
  },
  "mpolidori": {
    role: "Software Engineer",
    fullname: "Michael Polidori"
  },
  "monikappv": {
    role: "Web Designer",
    fullname: "Monika Popova"
  },
  "gavram": {
    role: "Software Engineer",
    fullname: "Dragan Avramovic"
  },
  "gabrielailieva": {
    role: "Office Manager & People Person",
    fullname: "Gabriela Ilieva"
  },
  "Daniellappv": {
    role: "Datopian Leadership",
    fullname: "Daniela Popova"
  },
  "cynepton": {
    role: "Software Engineer",
    fullname: "Isaac Aderonmu"
  },
  "MaiadaElKhalifa": {
    role: "CEO",
    fullname: "Maiada El Khalifa"
  },
  "Kalasha83": {
    role: "Finance Manager & Operations",
    fullname: "Anastasia Kalashnikova"
  },
  "juanbrits": {
    role: "Product Owner",
    fullname: "Juan Brits"
  },
  "lucasmbispo": {
    role: "Software Engineer",
    fullname: "Lucas Bispo"
  },
  "luccasmmg": {
    role: "Software Engineer",
    fullname: "Luccas Mateus"
  },
  "geoffrey1330": {
    role: "Software Engineer",
    fullname: "Israel Geoffrey"
  },
  "demenech": {
    role: "Software Engineer",
    fullname: "João Demenech"
  },
  "LyudmilaSuprun": {
    role: "Operations & Finance Assistant",
    fullname: "Lyudmila Suprun"
  },
  "Mikanebu": {
    role: "Software Engineer",
    fullname: "Meiran Zhiyenbayev"
  },
  "sneha-sharma12": {
    role: "Software Engineer",
    fullname: "Sneha Sharma"
  },
  "svetozarstojkovicdatopian": {
    role: "Software Engineer",
    fullname: "Svetozar Stojkovic"
  },
  "willy1989cv": {
    role: "Software Engineer",
    fullname: "William Lima"
  },
  "rufaro-dato": {
    role: "Software Engineer",
    fullname: "Rufaro Dato"
  },
  "ChyOakley": {
    role: "Legal Advisor",
    fullname: "Chioma Ameh"
  },
  "Datopian-Shreyas": {
    role: "Software Engineer",
    fullname: "Shreyas Muniyappa"
  },
  "gradedSystem": {
    role: "Software Engineer",
    fullname: "Yedige Ashmet"
  },
  "mohamedsalem401": {
    role: "Software Engineer",
    fullname: "Mohamed Yahia"
  },
  "shubham-mahajan": {
    role: "Senior Software Engineer",
    fullname: "Shubham Mahajan"
  },
  "lidiaproykina": {
    role: "Project Manager",
    fullname: "Lidia Proykina"
  },
  "muhammad-hassan11": {
    role: "Software Engineer",
    fullname: "Muhammad Hassan"
  },
  "olayway": {
    role: "Software Engineer",
    fullname: "Aleksandra Rubaj"
  },
  "RonaldojCampos": {
    role: "Software Engineer",
    fullname: "Ronaldo Campos"
  },
  "KirilYordanov": {
    role: "Project Manager",
    fullname: "Kiril Yordanov"
  },
  "Marodatopian": {
    role: "Project Manager",
    fullname: "Maro Okobiah"
  }
}

export default function Teams() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetch('https://api.github.com/orgs/datopian/members', {
      headers: {
        'Authorization': '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'
      }})
      .then(response => response.json())
      .then(data => {
        const membersData = data.map(async member => {
          if (typeof member.login === "undefined") return;
          const profileResponse = await fetch(member.url);
          const profileData = await profileResponse.json();
          return {
            name: profileData.name || typeof TeamMember[member.login] !=="undefined" ? TeamMember[member.login].fullname : member.login,
            role: TeamMember[member.login] ? TeamMember[member.login].role : "Software Engineer",
            imageUrl: member.avatar_url
          };
        });
        Promise.all(membersData).then(completedMembers => setMembers(completedMembers));
      });
  }, []);

  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" tabIndex={0}>
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="main-top-title">Team</h2>
          <p className="mt-6 main-text">
            Datopian is an internationally-distributed team of 30+ dedicated and experienced professionals, led by open-source and open data veterans and united by a passion for
            open-source and open-data innovation.Our remarkable lineup includes the creator of CKAN, the creators and lead curators of the Frictionless Data specifications,
            the masterminds behind DataHub.io and PortalJS, the creative forces behind Flowershow, as well as some of the most prominent open data pioneers and activists worldwide.

            At Datopian, we&apos;re not just a team - we&apos;re a collaborative community of experts, driven by our shared commitment to harnessing the power of data to create a better, more connected world.

          </p>
        </div>
        <ul
          role="list"
          className="mx-auto mt-20 grid max-w-2xl grid-cols-2 gap-x-8 gap-y-16 text-center sm:grid-cols-3 md:grid-cols-4 lg:mx-0 lg:max-w-none lg:grid-cols-5 xl:grid-cols-6"
        >
          {members.map((person) => (
            <li key={person.name}>
              <Image width={240} height={240} className="mx-auto h-24 w-24 rounded-full" src={person.imageUrl} alt="" />
              <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900">{person.name}</h3>
              <p className="text-sm leading-6 text-gray-600">{person.role}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
